<template>
  <!-- 25.6.10 联系方式 dxm -->
  <div class="flex flex_wrap">
    <div class="contact_wrap" v-for="(item, index) in list" :key="index">
      <div class="contact_title">
        {{ langSet == "cn" ? item.name : item.name_en }}
      </div>
      <div class="contact_phone flex flex_items_center">
        <img
          class="icon"
          :src="require('../assets/imgs/c_img1.png')"
          alt=""
        />{{ item.landline }}
      </div>
      <div class="contact_tel flex flex_items_center">
        <img
          class="icon"
          :src="require('../assets/imgs/c_img2.png')"
          alt=""
        />{{ item.mobile }}
      </div>
      <div class="contact_email flex flex_items_center">
        <img
          class="icon"
          :src="require('../assets/imgs/c_img3.png')"
          alt=""
        />{{ item.email }}
      </div>
      <!-- 25.11.11 新增企业微信二维码 dxm -->
      <img class="wx_code" :src="item.wx_code" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
  },
  data() {
    return {
      langSet: "",
    };
  },
  created() {},
  mounted() {
    this.langSet = this.$language;
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.contact_wrap {
  width: calc((100% - 40px) / 2);
  height: 240px;
  padding: 40px;
  color: #000;
  font-size: 18px;
  line-height: 30px;
  box-sizing: border-box;
  background: #f7f8fa;
  margin-right: 40px;
  margin-top: 40px;
  position: relative;
  &:nth-child(2n) {
    margin-right: 0;
  }
  > div {
    margin-top: 10px;
  }
  .contact_title {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  .icon {
    width: 20px;
    margin-right: 11px;
  }
  .wx_code {
    position: absolute;
    bottom: 50%;
    right: 30px;
    width: 150px;
    height: 150px;
    transform: translateY(50%);
  }
}
@media only screen and (max-width: 1280px) {
  .contact_wrap .wx_code {
    right: 20px;
    width: 120px;
    height: 120px;
  }
}
@media only screen and (max-width: 767px) {
  .contact_wrap {
    width: 100%;
    height: 2.88rem;
    padding: 0.28rem;
    font-size: 0.27rem;
    line-height: 0.38rem;
    background: #f7f8fa;
    margin-right: 0;
    margin-top: 0.38rem;
    &:nth-child(2n) {
      margin-right: 0;
    }
    > div {
      margin-top: 0.19rem;
    }
    .contact_title {
      font-size: 0.31rem;
      font-weight: 500;
      margin-bottom: 0.21rem;
    }
    .icon {
      width: 0.35rem;
      margin-right: 0.12rem;
    }
    .wx_code {
      right: 10px;
      bottom: 53%;
      width: 90px;
      height: 90px;
    }
  }
}
</style>